<template>
  <div class="carousel" :style="{ backgroundImage: currentSlide.image ? 'url(' + currentSlide.image + ')' : '' }">
    <div class="carousel-content">
        <div class="text-card">
            <div class="fixed-text">Economia<br>suficiente para...</div>
            <div class="variable-text" v-html="currentSlide.text"></div>
        </div>
        <div class="indicators">
        <span
          v-for="(slide, idx) in slides"
          :key="idx"
          :class="{ active: idx === currentIndex }"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    slides: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      currentIndex: 0,
      interval: null
    };
  },
  computed: {
    currentSlide() {
      return this.slides[this.currentIndex] || {};
    }
  },
  mounted() {
    this.startCarousel();
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    startCarousel() {
      if (this.interval) clearInterval(this.interval);
      this.interval = setInterval(() => {
        if (this.slides && this.slides.length > 0) {
          this.currentIndex = (this.currentIndex + 1) % this.slides.length;
        }
      }, 3000);
    }
  },
  watch: {
    slides() {
      this.currentIndex = 0;
      this.startCarousel();
    }
  }
};
</script>

<style scoped>
.carousel {
  width: 320px;
  height: 180px;
  border-radius: 16px;
  position: relative;
  overflow: hidden;
  color: #fff;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  background-size: cover;
  background-position: center;
}
.carousel-content {
  width: 100%;
  height: 100%;
  padding: 20px;
  position: relative;
  z-index: 2;
}
.fixed-text {
    color: #FFF;
    font-family: Manrope;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}
.variable-text {
    color:#FFF;
    font-family: Manrope;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}
.carousel-image {
  display: none;
}
.indicators {
  position: absolute;
  bottom: 15px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 6px;
  z-index: 3;
}
.indicators span {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #fff6;
  display: inline-block;
  transition: background 0.3s;
}
.indicators .active {
  background: #fff;
}
.text-card{
    display: flex;
    width: 107px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 34px;
}
</style>
